import { Map } from "leaflet";

import { useMeasureConfigs } from "hooks/measureConfigHooks";
import { useStudyArea } from "hooks/studyAreaHooks";

import { RenderMeasureConfigs } from "components/measures/addMeasurePage/RenderMeasureConfigs";
import { RenderStudyArea } from "components/map/layers/RenderStudyArea";

interface Props {
  uuid: string;
  mapRef: Map;
}

export function MeasuresAndStudyArea(props: Props) {
  const { uuid, mapRef } = props;

  const { data: measureConfigs } = useMeasureConfigs(uuid);
  const { data: studyArea } = useStudyArea(uuid);

  return (
    <>
      {measureConfigs && (
        <RenderMeasureConfigs mapRef={mapRef} measureConfigs={measureConfigs} />
      )}
      {studyArea && (
        <RenderStudyArea
          mapRef={mapRef}
          studyAreaGeo={studyArea.geometry_4326}
        />
      )}
    </>
  );
}
